import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IDeleteModal from './interfaces/IDeleteModal';

export default function DeleteModal({
  open,
  onReject,
  isLoading,
  onConfirm,
  name,
  title,
  titleKey,
  hint,
  hintKey,
  hintClassName,
  confirmTitle,
}: IDeleteModal) {
  const { t } = useTranslation();
  const modalTitleKey = titleKey || (title ? `common.${title}` : 'common.deleteValueChainMap');
  const modalHintKey = hintKey || (hint ? `common.${hint}` : 'common.thisActionCannotBeUndone');

  return (
    <Modal
      open={open}
      title={t(modalTitleKey, { name })}
      description={t(modalHintKey)}
      closeTitle={t('common.cancel')}
      confirmTitle={confirmTitle || t('common.delete')}
      confirmVariant={BUTTON_VARIANT.error}
      onReject={onReject}
      onConfirm={onConfirm}
      isLoading={isLoading}
      hintClassName={hintClassName}
    />
  );
}
